import {Stack, styled} from '@mui/material';

const StyledContainer = styled(Stack)`
	gap: 16px;
`;

const StyledUnOrderList = styled('ul')`
	list-style: disc;
	padding-left: 24px;
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export {StyledContainer, StyledUnOrderList};
